const state = {
  burgerMenuOpen: false,
};

const getters = {
  burgerMenuOpen(state) {
    return state.burgerMenuOpen;
  },
};

const mutations = {
  setBurgerMenuOpen(state, payload) {
    state.burgerMenuOpen = payload;
  },
};

const actions = {
  setBurgerMenuOpen(context, payload) {
    context.commit('setBurgerMenuOpen', payload);
  },
  reset(context) {
    context.commit('setBurgerMenuOpen', false);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
